export default __webpack_public_path__ + "proximanova-regularit-webfont.woff2";